import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, textColumn } from "./ColumnHelpers";

export function column_SubmitterEmail(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "submitterEmail", "submitterEmail", {
		inputType: "email",
	});
}
